import LegacySidebar from '@groovepages/gd-ui-kit/components/SideBarNew';
import { createSidebarAdapter } from '../../../groove-ui-kit-v2/src/vue2/account-adapter';
export default createSidebarAdapter(LegacySidebar);
